import { TOGGLE_RESEARCH_MODE } from "./researchModeReducer"

export const toggleResearchMode = (value) => ({
    type: TOGGLE_RESEARCH_MODE,
    payload: value
})